export default __webpack_public_path__ + "static/media/Loop.29378cab.mp3";